import { AuditLiveMentionConfidence } from '@mi-front/core';
import { useAuditLiveMention } from '../../../../../../../../audit/hooks/useAuditLiveMention';
import { LiveMentionConfidenceButtons } from './LiveMentionConfidenceButtons';

type LiveMentionConfidenceControlsProps = {
  stationId: string;
  id: string;
  className?: string;
};

/**
 * Allows accepting or rejecting the confidence assigned to a live mention.
 */
export function LiveMentionConfidenceControls({
  stationId,
  id,
  className,
}: LiveMentionConfidenceControlsProps) {
  const { data, isLoading, confidenceMutation } = useAuditLiveMention(stationId, id);

  return (
    <LiveMentionConfidenceButtons
      className={className}
      confidence={data?.confidence ?? AuditLiveMentionConfidence.AUTO}
      isLoading={isLoading}
      onConfidenceChange={(confidence) => confidenceMutation.mutate(confidence)}
    />
  );
}
